export default "__VITE_ASSET__DqENsxJe__"